import FilesPage from './FilesPage';
import FileInfoModalSidebar from './FileInfoModalSidebar';

export default FilesPage;
export { FileInfoModalSidebar };
